export type BusinessPlacementRecord = {
  hasActiveAdvertisement?: boolean | null;
  membershipTier?: string | null;
  subscriptionStatus?: string | null;
};

export type BusinessPlacementLevel = "advertiser" | "premium" | "regular";

export function getBusinessPlacementLevel(
  business: BusinessPlacementRecord,
): BusinessPlacementLevel {
  if (business.hasActiveAdvertisement === true) return "advertiser";

  const tier = String(
    business.membershipTier || business.subscriptionStatus || "free",
  ).toLowerCase();
  if (tier === "premium" || tier === "platinum") return "premium";

  return "regular";
}

export function getBusinessPlacementPriority(
  business: BusinessPlacementRecord,
): number {
  const level = getBusinessPlacementLevel(business);
  if (level === "advertiser") return 3;
  if (level === "premium") return 2;
  return 1;
}

/**
 * Stable promotion ordering for business recommendation surfaces.
 * The caller's existing relevance or recency order is preserved within a tier.
 */
export function rankBusinessPlacements<T extends BusinessPlacementRecord>(
  businesses: readonly T[],
): T[] {
  return businesses
    .map((business, index) => ({ business, index }))
    .sort((a, b) => {
      const priority =
        getBusinessPlacementPriority(b.business) -
        getBusinessPlacementPriority(a.business);
      return priority || a.index - b.index;
    })
    .map(({ business }) => business);
}
